export default "__VITE_ASSET__DlcbKpb7__"